import React from 'react';
import Query from '../../../../graphql/Query';
import { GET_FILTERS_OPTIONS } from '../../graphql';
import FilterView from './FilterView';
import { FilterQueryProps, DefaultFormFields } from '../../../../ui-kit/FilterComponent/types';
import { FiltersProps } from './types';

const Filters = <T extends DefaultFormFields, >({ handleChange, formData, ...rest }: FiltersProps<T> ) => (
    <Query<FilterQueryProps> query={GET_FILTERS_OPTIONS}>
        {({ data: { sections, employees } }) => (
            <FilterView
                sections={sections}
                employees={employees}
                handleChange={handleChange}
                formData={formData}
                {...rest}
            />
        )}
    </Query>
);

export default Filters;
